/** Every module's web half. */
import core from "./core/web";
import herd from "./herd/web";
import breeding from "./breeding/web";
import genetics from "./genetics/web";
import health from "./health/web";
import performance from "./performance/web";
import land from "./land/web";
import feeding from "./feeding/web";
import finance from "./finance/web";
import operations from "./operations/web";
import reports from "./reports/web";
import sales from "./sales/web";
import dairy from "./dairy/web";
import sessions from "./sessions/web";
import data from "./data/web";
import type { WebModule } from "../web/module";

export const webParts: WebModule[] = [core, herd, breeding, genetics, health, performance, land, feeding, finance, operations, reports, sales, dairy, sessions, data];
